import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { MenuItem, TextField } from "@mui/material";
import { useImmer } from "use-immer";
import "./AddEditChatbot.css";
import Builder from "./Builder";
// import Preview from "./Preview";
import { createWAChatBot, editWAChatBot } from "../../Store/Actions/WABAAction";

const AddEditChatbot = ({ action, handleBack, selectedChatbot }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialChatbotValues = {
    name: "",
    id: "",
    useTicket: false,

    sections: [
      {
        section_id: "start",
        name: "Welcome",
        type: "start",
        value: "",
        options: [{ route: "end", key: "" }],
      },

      {
        section_id: "end",
        name: "End",
        type: "end",
        value: "",
      },
    ],

    handlers: {
      timeout: {
        value: "",
        max_time: 120,
        route: "end",
      },

      wrong_input: {
        value: "",
        max_try: 3,
        route: "end",
      },
    },
  };

  // useImmer used for easier state update
  const [chatbotValues, updateChatbotValues] = useImmer(initialChatbotValues);

  useEffect(() => {
    if (selectedChatbot !== null) {
      updateChatbotValues((draft) => {
        draft.name = selectedChatbot.ScriptName;
        draft.id = selectedChatbot.ID;

        draft.useTicket = selectedChatbot.UseTicket
          ? selectedChatbot.UseTicket
          : false;

        draft.sections = JSON.parse(selectedChatbot.ScriptBody).sections;
        draft.handlers = JSON.parse(selectedChatbot.ScriptBody).handlers;
      });
    }
  }, [selectedChatbot]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    action === "add"
      ? createWAChatBot({
          scriptname: chatbotValues.name,

          scriptbody: JSON.stringify({
            sections: chatbotValues.sections,
            handlers: chatbotValues.handlers,
          }),

          responsetimelimit: chatbotValues.handlers.timeout.max_time,
          isuseticket: chatbotValues.useTicket,
        })
          .then((response) => {
            if (response.status) {
              setIsSubmitting(false);
              toast.success("Chatbot added successfully");
              updateChatbotValues(() => initialChatbotValues);
              handleBack();
            } else {
              console.log("error", response.error);
              toast.error(response.error);
              setIsSubmitting(false);
            }
          })
          .catch((err) => {
            console.log("error", err);
            toast.error(err);
            setIsSubmitting(false);
          })
      : editWAChatBot({
          chatbotscriptid: chatbotValues.id,
          scriptname: chatbotValues.name,

          scriptbody: JSON.stringify({
            sections: chatbotValues.sections,
            handlers: chatbotValues.handlers,
          }),

          responsetimelimit: chatbotValues.handlers.timeout.max_time,
          isuseticket: chatbotValues.useTicket,
        })
          .then((response) => {
            if (response.status) {
              setIsSubmitting(false);
              toast.success("Chatbot updated successfully");
              updateChatbotValues(() => initialChatbotValues);
              handleBack();
            } else {
              console.log("error", response.error);
              toast.error(response.error);
              setIsSubmitting(false);
            }
          })
          .catch((err) => {
            console.log("error", err);
            toast.error(err);
            setIsSubmitting(false);
          });
  };

  return (
    <div className="add-edit-chatbot">
      <p className="subtitle">Chatbot Detail</p>

      <form onSubmit={handleSubmit}>
        <div className="form-container">
          <TextField
            autoComplete="false"
            fullWidth
            label="Name"
            required
            value={chatbotValues.name}
            onChange={(e) =>
              updateChatbotValues((draft) => {
                draft.name = e.target.value;
              })
            }
          />

          {action === "edit" && (
            <TextField
              fullWidth
              InputProps={{ readOnly: true }}
              label="ID"
              value={chatbotValues.id}
              onChange={(e) =>
                updateChatbotValues((draft) => {
                  draft.id = e.target.value;
                })
              }
            />
          )}

          <TextField
            fullWidth
            InputProps={{ readOnly: true }}
            label="Status"
            value="Inactive"
          />

          <TextField
            fullWidth
            label="Use Ticket"
            required
            select
            value={chatbotValues.useTicket}
            onChange={(e) =>
              updateChatbotValues((draft) => {
                draft.useTicket = e.target.value;
              })
            }
          >
            <MenuItem value={true}>Yes</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </TextField>
        </div>

        <div className="builder-preview-container">
          <Builder
            chatbotValues={chatbotValues}
            updateChatbotValues={updateChatbotValues}
          />

          {/* <Preview chatbotValues={chatbotValues} /> */}
        </div>

        <section className="buttons">
          <button
            className="cancel"
            type="button"
            onClick={() => {
              updateChatbotValues(() => initialChatbotValues);
              handleBack();
            }}
          >
            Cancel
          </button>

          <button className="confirm" disabled={isSubmitting} type="submit">
            {isSubmitting && <Icon height="28" icon="eos-icons:loading" />}
            {action === "add" ? "Submit" : "Save"}
          </button>
        </section>
      </form>
    </div>
  );
};

export default AddEditChatbot;
